import { defineComponent as _defineComponent } from 'vue'
import { watch } from 'vue'
import { Skeleton, Spin, Empty } from 'ant-design-vue'
import useList from '@/hooks/useList'
import { getNoticeList } from '@/api/notice'
import routerByNoticeTag from '@/utils/noticeTag'
import { toDetail } from '@/utils'
import useInit from '@/hooks/useInit'
import { getHTMLText } from '@/utils/index'

type Props = {
  /** 显示顶部的分页器 */
  showTopPagination?: boolean
  /** 列表所查询的`noticeTag` */
  noticeTags: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TagList',
  props: {
    showTopPagination: { type: Boolean, default: true },
    noticeTags: null
  },
  setup(__props: any) {

const props = __props as { showTopPagination: boolean, noticeTags: string };



const { dataList, loading, pagination, onQueryList } = useList<NoticeItem>({
  getList: getNoticeList,
  formatGetListQuery(query) {
    return {
      ...query,
      noticeTags: props.noticeTags,
      /** 排序方式 1 创建时间 2 发布时间倒序 3 浏览量 4 发布时间正序 */
      sortBy: 2,
    }
  },
})

const { loading: skeletonLoading } = useInit(dataList)

watch(
  () => [pagination.current, pagination.pageSize],
  () => {
    onQueryList()
  }
)

function onClickTag(item: NoticeItem) {
  // routerByNoticeTag(item.noticeTag)
  window.open(`/#/searchPage/index?value=${item.title.replace(/\w/g, '')}`, '_blank')
}

function onClick(item: NoticeItem) {
  toDetail(item)
}

return { __sfc: true,props, dataList, loading, pagination, onQueryList, skeletonLoading, onClickTag, onClick, Skeleton, Spin, Empty, getHTMLText }
}

})